import { useQuery } from '@tanstack/react-query';
import getInspectionAssistantInsights from '../services/AnalyticReportsService';
export default function useInspectionAssistantInsights(filters) {
    return useQuery(['inspectionAssistantInsights', filters], () => getInspectionAssistantInsights(filters), {
        staleTime: 5 * 60 * 1000, // Consider data stale after 5 minutes
        cacheTime: 30 * 60 * 1000 // Keep unused data in cache for 30 minutes
    });
}
